import { useEffect, useState } from "react"

// TODO: заменить на запрос к бэку, когда появится эндпоинт с баллами пользователя
const MOCK_USER_POINTS = 0
const MOCK_DELAY_MS = 400

// null — баллы ещё загружаются (или пользователь неизвестен)
export const useUserPoints = (): number | null => {
    const [points, setPoints] = useState<number | null>(null)

    useEffect(() => {
        const timer = setTimeout(() => setPoints(MOCK_USER_POINTS), MOCK_DELAY_MS)
        return () => clearTimeout(timer)
    }, [])

    return points
}
